var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupMenuDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8889 0.888672V3.77757M5.11108 0.888672V3.77757",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8889 0.888672V3.77757M5.11108 0.888672V3.77757",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72225 2.33398H7.2778C4.55412 2.33398 3.19228 2.33398 2.34614 3.18012C1.5 4.02627 1.5 5.3881 1.5 8.11179V9.55624C1.5 12.2799 1.5 13.6418 2.34614 14.4879C3.19228 15.334 4.55412 15.334 7.2778 15.334H8.72225C11.4459 15.334 12.8078 15.334 13.6539 14.4879C14.5001 13.6418 14.5001 12.2799 14.5001 9.55624V8.11179C14.5001 5.3881 14.5001 4.02627 13.6539 3.18012C12.8078 2.33398 11.4459 2.33398 8.72225 2.33398Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72225 2.33398H7.2778C4.55412 2.33398 3.19228 2.33398 2.34614 3.18012C1.5 4.02627 1.5 5.3881 1.5 8.11179V9.55624C1.5 12.2799 1.5 13.6418 2.34614 14.4879C3.19228 15.334 4.55412 15.334 7.2778 15.334H8.72225C11.4459 15.334 12.8078 15.334 13.6539 14.4879C14.5001 13.6418 14.5001 12.2799 14.5001 9.55624V8.11179C14.5001 5.3881 14.5001 4.02627 13.6539 3.18012C12.8078 2.33398 11.4459 2.33398 8.72225 2.33398Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.66797H14.5001",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.66797H14.5001",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99673 9.55469H8.00324M7.99673 12.4436H8.00324M10.8824 9.55469H10.8889M5.11108 9.55469H5.11756M5.11108 12.4436H5.11756",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99673 9.55469H8.00324M7.99673 12.4436H8.00324M10.8824 9.55469H10.8889M5.11108 9.55469H5.11756M5.11108 12.4436H5.11756",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuDetails);
export default __webpack_public_path__ + "static/media/group_menu_details.71dec65dbb36acfbfd3d2bae1bb27850.svg";
export { ForwardRef as ReactComponent };